import React, { useRef, useState } from "react";
import * as d3 from "d3";
import { useEffect } from "react";
import { FormatYear } from "../constants";
const LineChart = ({
  datasets,
  id,
  SetChartToolTip,
  ClearLocationToolTip,
  barColor,
  stratificationID,
    deviceType,
    SetChartToolTipKeyboard,
}) => {
  useEffect(() => {
    changeData();
  }, [stratificationID]);

    const chartRef = useRef(null);

    const [stateIndex, setStateIndex] = useState(0);
    const [isFirst, setIsFirst] = useState(true);

  const margin = 60;
  const width = 650 - margin * 2;
  const height = 410 - margin * 2;

  function ShowLineChart(DataItems) {
    const currentChart = document.querySelector("svg#" + id);
    if (currentChart !== null) currentChart.remove();

    const DataValueUnit =
      DataItems[0].DataValueType === "Number" ||
      DataItems[0].DataValueUnit === "gallons"
        ? ""
        : "(" + DataItems[0].DataValueUnit + ")";

    const svg = d3
      .select("#" + id)
      .append("svg")
      .attr("id", id)
      .attr("width", width + margin * 2)
      .attr("height", height + margin * 2);

    const xScale = d3.scalePoint().range([0, width]);
    const yScale = d3.scaleLinear().range([height, 0]);

    const g = svg
      .append("g")
      .attr("transform", "translate(" + margin + "," + margin + ")");

      xScale.domain(DataItems.map((d) => FormatYear(d.YearStart, d.YearEnd)));
    yScale.domain([
      0,
      d3.max(DataItems, (d) => d.DataValue + d.DataValue / 10),
    ]);

    // Add X Axis
    g.append("g")
      .attr("transform", "translate(0," + height + ")")
      .call(d3.axisBottom(xScale));

    // Add Y axis
    g.append("g")
      .call(d3.axisLeft(yScale))
      .append("text")
      .attr("class", "yAxisLabel")
      .attr("fill", "black")
      .attr("font-size", "15")
      .attr("font-weight", "bold")
      .text(DataItems[0].DataValueType + " " + DataValueUnit);

    // Add the line
    g.append("path")
      .datum(DataItems)
      .attr("fill", "none")
      .attr("stroke", "#005046")
      .attr("stroke-width", 1.5)
      .attr(
        "d",
        d3
          .line()
            .x((d) => xScale(FormatYear(d.YearStart, d.YearEnd)))
          .y((d) => yScale(d.DataValue))
          .defined((d) => d.DataValue)
      );

    // Add the Dots
    g.append("g")
      .selectAll("dot")
      .data(DataItems)
      .enter()
        .append("circle")
        .attr("class", "graph-text")
        .attr("cx", (d) => xScale(FormatYear(d.YearStart, d.YearEnd)))
      .attr("cy", (d) => (d.DataValue === "null" ? 0 : yScale(d.DataValue)))
      .attr("r", 7)
      .attr("fill", (d) => {
        return d.DataValue === null ? "none" : barColor;
      })
        .attr("stratid", (d) => d.StratificationID)
        .attr("locid", (d) => d.LocationAbbr)
        .attr("aria-label", function (d, i) {
            return getAriaTextForMapLocation(d, i, d.LocationAbbr);
        })
      .on("mouseover", function (mouseEvent, locationInfo) {
        if (deviceType === "mobile") return;
        SetChartToolTip(mouseEvent, locationInfo);
      })
      .on("mouseout", function () {
        if (deviceType === "mobile") return;
        ClearLocationToolTip("clear");
      })
      .on("click", function (mouseEvent, locationInfo) {
        if (deviceType === "desktop") return;
        const toolTipOffSet = 0.25;
        SetChartToolTip(mouseEvent, locationInfo, toolTipOffSet);
      });
  }
  function changeData() {
    ShowLineChart(datasets.DataItems);
  }
    function handleKeyDown(event) {
        var itemList = chartRef.current?.querySelectorAll(".graph-text");

        if (event.code === "Tab" && event.shiftKey) {
            //nothing. let's just catch it
        }
        else if (event.code === "End") {
            event.preventDefault();
            let nextIndex = null;
            if (isFirst) {
                nextIndex = 0;
                setIsFirst(false);
            } else {
                nextIndex = itemList.length - 1;
            }


            itemList.forEach((item, i) => {
                item.setAttribute("aria-selected", "false");
                item.classList.remove("graph-focus");
            });

            itemList[nextIndex].classList.add("graph-focus");
            itemList[nextIndex].focus();

            itemList[nextIndex].setAttribute("aria-selected", "true");
            setStateIndex(nextIndex);

            scrollIntoViewIfNotVisible(itemList[nextIndex]);

        }
        else if (event.code === "Home") {
            event.preventDefault();
            let nextIndex = null;
            if (isFirst) {
                nextIndex = 0;
                setIsFirst(false);
            } else {
                nextIndex = 0;
            }


            itemList.forEach((item, i) => {
                item.setAttribute("aria-selected", "false");
                item.classList.remove("graph-focus");
            });

            itemList[nextIndex].classList.add("graph-focus");
            itemList[nextIndex].focus();

            itemList[nextIndex].setAttribute("aria-selected", "true");
            setStateIndex(nextIndex);

            scrollIntoViewIfNotVisible(itemList[nextIndex]);

        }
        else if (event.code !== "Tab") {
            event.preventDefault();
            if (event.code === "ArrowDown") {
                console.log("arrow down");

                let nextIndex = null;
                if (isFirst) {
                    nextIndex = 0;
                    setIsFirst(false);
                } else {
                    nextIndex = stateIndex + 1;
                }

                if (nextIndex < itemList.length) {
                    itemList.forEach((item, i) => {
                        item.setAttribute("aria-selected", "false");
                        item.classList.remove("graph-focus");
                    });

                    itemList[nextIndex].classList.add("graph-focus");
                    itemList[nextIndex].focus();

                    //   chartRef .current?.setAttribute('aria-activedescendant', itemList[nextIndex].id);
                    itemList[nextIndex].setAttribute("aria-selected", "true");
                    setStateIndex(nextIndex);

                    scrollIntoViewIfNotVisible(itemList[nextIndex]);
                }
            } else if (event.code === "ArrowUp") {
                console.log("arrow up");

                let nextIndex = null;
                if (isFirst) {
                    nextIndex = 0;
                    setIsFirst(false);
                } else {
                    nextIndex = stateIndex - 1;
                }
                if (nextIndex > -1) {
                    itemList.forEach((item, i) => {
                        item.setAttribute("aria-selected", "false");
                        item.classList.remove("graph-focus");
                    });

                    //  chartRef .current?.setAttribute('aria-activedescendant', itemList[nextIndex].id);
                    itemList[nextIndex].setAttribute("aria-selected", "true");
                    itemList[nextIndex].classList.add("graph-focus");
                    itemList[nextIndex].focus();

                    setStateIndex(nextIndex);

                    scrollIntoViewIfNotVisible(itemList[nextIndex]);
                }
            } else if (event.code === "Enter") {
                const stratid = itemList[stateIndex].getAttribute("stratid");
                const locid = itemList[stateIndex].getAttribute("locid");
                const y = itemList[stateIndex].getAttribute("y");
                const x = itemList[stateIndex].getAttribute("x");

                const items = datasets.DataItems.filter(x => x.LocationAbbr === locid && x.StratificationID === stratid);
                if (items && items.length > 0) {
                    let ctm = itemList[stateIndex].getCTM();

                    SetChartToolTipKeyboard(ctm.e, ctm.f, event, itemList[stateIndex], items[0])
                }
                //const textColor = getTextColor(itemList[stateIndex].id, topic_code);
                //const fillColor = getColor(itemList[stateIndex].id, topic_code);
                //ShowToolTip(itemList[stateIndex], itemList[stateIndex].id, true);
            }
        }
    }


    function scrollIntoViewIfNotVisible(target) {
        if (target.getBoundingClientRect().bottom > window.innerHeight) {
            target.scrollIntoView(false);
        }

        if (target.getBoundingClientRect().top < 0) {
            target.scrollIntoView();
        }
    }

    function handleBlur(event) {
        var itemList = chartRef.current?.querySelectorAll(".graph-text");

        itemList.forEach((item, i) => {
            item.classList.remove("graph-focus");
        });

        //setIsFirst(true);
        //setStateIndex(0);
    }
    function getAriaTextForMapLocation(d, i, locationCode) {
        const locations = datasets.DataItems.filter((x) => x.LocationAbbr === locationCode);
        const locationText = locations && locations.length > 0 ? locations[0].LocationDesc : null;

        if (locationText !== null) {
            const stratid = d.StratificationID;
            const locid = d.LocationAbbr;
            const items = datasets.DataItems.filter(x => x.LocationAbbr === locid && x.StratificationID === stratid);

            if (d && d.DataValue !== null) {
                return `Select to see data for ${d.Stratification}, ${d.LocationDesc}`;
            }
            else {
                return `Data not available for ${d.Stratification}, ${d.LocationDesc}`;
            }
        }
        else {

            return "Error creating text"
        }
    }
    return <div
        onKeyDown={handleKeyDown}
        tabIndex="0"
        onBlur={handleBlur}
        role="listbox"
        aria-label="Line Graph"
        aria-describedby={"keyItems_" + id}
        aria-keyshortcuts="ArrowUp,ArrowDown,Home,End"
    >
        <div id={id} ref={chartRef} className="trendline-chart"></div>
    </div>;
};

export default LineChart;
